import { type PropsWithChildren } from 'react'
import axios, { type InternalAxiosRequestConfig } from 'axios';
import qs from 'qs';
import { axiosContext } from './axios-context';
import { useAuth } from '@lib/auth/use-auth.ts';

export const AxiosApiProvider = ({ children }: PropsWithChildren) => {
    const { getAccessTokenSilently } = useAuth();

    const axiosInstance = axios.create({
        baseURL: import.meta.env.VITE_API_URL,
        paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false, arrayFormat: 'repeat' });
        },
    });

    axiosInstance.interceptors.request.use(async (request: InternalAxiosRequestConfig) => {
        const token = await getAccessTokenSilently();
        request.headers.Authorization = `Bearer ${token}`;

        return request;
    });

    axiosInstance.interceptors.request.use((request: InternalAxiosRequestConfig) => {
        request.headers.set('X-Correlation-ID', crypto.randomUUID());
        return request;
    });


    return <axiosContext.Provider value={axiosInstance}>{children}</axiosContext.Provider>;
};
